import { useI18n } from '../i18n';
import { useRoutes } from '../hooks/useRoutes';
import { Link } from 'react-router-dom';
import './TutorialContent.css';

/**
 * Tutorial sayfasının altında gösterilen kalıcı SEO içeriği.
 * Sudoku kuralları, genel ipuçları, yaygın hatalar ve SSS bölümleri.
 *
 * Tüm metin shared/src/i18n/{locale}.json'daki `tutorialContent.*` key'lerinden
 * gelir (N-dil desteği için — eski `en ? 'EN' : 'TR'` ternary deseni kaldırıldı).
 */
export function TutorialContent() {
  const { t } = useI18n();
  const { r } = useRoutes();
  const s = t.tutorialContent as any;

  return (
    <article className="tut-content">
      <section className="tut-content-section">
        <h2>{s.whatIsTitle}</h2>
        <p>{s.whatIsP1}</p>
        <p>{s.whatIsP2}</p>
      </section>

      <section className="tut-content-section">
        <h2>{s.rulesTitle}</h2>
        <ol>
          <li><strong>{s.ruleRowsLabel}</strong>{s.ruleRowsDesc}</li>
          <li><strong>{s.ruleColsLabel}</strong>{s.ruleColsDesc}</li>
          <li><strong>{s.ruleBoxesLabel}</strong>{s.ruleBoxesDesc}</li>
        </ol>
      </section>

      <section className="tut-content-section">
        <h2>{s.strategyTitle}</h2>
        <ol>
          <li><strong>{s.strategy1Label}</strong>{s.strategy1Desc}</li>
          <li><strong>{s.strategy2Label}</strong>{s.strategy2Desc}</li>
          <li><strong>{s.strategy3Label}</strong>{s.strategy3Desc}</li>
          <li><strong>{s.strategy4Label}</strong>{s.strategy4Desc}</li>
          <li>
            <strong>{s.strategy5Label}</strong>
            {s.strategy5Pre}{' '}
            <Link to={r('education', 'x-wing')}>{s.strategy5XWing}</Link>,{' '}
            <Link to={r('education', 'swordfish')}>{s.strategy5Swordfish}</Link>,{' '}
            <Link to={r('education', 'xy-wing')}>{s.strategy5XYWing}</Link>{' '}
            {s.strategy5Mid}{' '}
            <Link to={r('education')}>{s.strategy5LibraryLink}</Link>
            {s.strategy5Post}
          </li>
        </ol>
      </section>

      <section className="tut-content-section">
        <h2>{s.tipsTitle}</h2>
        <ul>
          <li>{s.tip1}</li>
          <li>{s.tip2}</li>
          <li>{s.tip3}</li>
          <li>{s.tip4}</li>
        </ul>
      </section>

      <section className="tut-content-section">
        <h2>{s.mistakesTitle}</h2>
        <ul>
          <li><strong>{s.mistake1Label}</strong>{s.mistake1Desc}</li>
          <li><strong>{s.mistake2Label}</strong>{s.mistake2Desc}</li>
          <li><strong>{s.mistake3Label}</strong>{s.mistake3Desc}</li>
          <li><strong>{s.mistake4Label}</strong>{s.mistake4Desc}</li>
        </ul>
      </section>

      <section className="tut-content-section">
        <h2>{s.faqTitle}</h2>
        <details className="tut-faq">
          <summary>{s.faq1Q}</summary>
          <p>{s.faq1A}</p>
        </details>
        <details className="tut-faq">
          <summary>{s.faq2Q}</summary>
          <p>{s.faq2A}</p>
        </details>
        <details className="tut-faq">
          <summary>{s.faq3Q}</summary>
          <p>{s.faq3A}</p>
        </details>
        <details className="tut-faq">
          <summary>{s.faq4Q}</summary>
          <p>
            {s.faq4Pre}{' '}
            <Link to={r('solver')}>{s.faq4SolverLink}</Link>{' '}
            {s.faq4Post}
          </p>
        </details>
      </section>

      <section className="tut-content-section tut-content-cta">
        <h2>{s.ctaTitle}</h2>
        <p>{s.ctaDesc}</p>
        <div className="tut-content-cta-row">
          <Link to={r('play')} className="tut-content-cta-btn tut-content-cta-btn--primary">
            {s.ctaPlay}
          </Link>
          <Link to={r('daily')} className="tut-content-cta-btn">
            {s.ctaDaily}
          </Link>
          <Link to={r('education')} className="tut-content-cta-btn">
            {s.ctaLibrary}
          </Link>
        </div>
      </section>
    </article>
  );
}
